/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountCsvData } from './AccountCsvData';
import {
    AccountCsvDataFromJSON,
    AccountCsvDataFromJSONTyped,
    AccountCsvDataToJSON,
    AccountCsvDataToJSONTyped,
} from './AccountCsvData';
import type { ModificationTimestamp } from './ModificationTimestamp';
import {
    ModificationTimestampFromJSON,
    ModificationTimestampFromJSONTyped,
    ModificationTimestampToJSON,
    ModificationTimestampToJSONTyped,
} from './ModificationTimestamp';

/**
 * 
 * @export
 * @interface AccountUpdateDataModel
 */
export interface AccountUpdateDataModel {
    /**
     * 
     * @type {Array<ModificationTimestamp>}
     * @memberof AccountUpdateDataModel
     */
    updatedAt: Array<ModificationTimestamp>;
    /**
     * 
     * @type {AccountCsvData}
     * @memberof AccountUpdateDataModel
     */
    account: AccountCsvData;
}

/**
 * Check if a given object implements the AccountUpdateDataModel interface.
 */
export function instanceOfAccountUpdateDataModel(value: object): value is AccountUpdateDataModel {
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('account' in value) || value['account'] === undefined) return false;
    return true;
}

export function AccountUpdateDataModelFromJSON(json: any): AccountUpdateDataModel {
    return AccountUpdateDataModelFromJSONTyped(json, false);
}

export function AccountUpdateDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountUpdateDataModel {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedAt': ((json['updatedAt'] as Array<any>).map(ModificationTimestampFromJSON)),
        'account': AccountCsvDataFromJSON(json['account']),
    };
}

export function AccountUpdateDataModelToJSON(json: any): AccountUpdateDataModel {
    return AccountUpdateDataModelToJSONTyped(json, false);
}

export function AccountUpdateDataModelToJSONTyped(value?: AccountUpdateDataModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updatedAt': ((value['updatedAt'] as Array<any>).map(ModificationTimestampToJSON)),
        'account': AccountCsvDataToJSON(value['account']),
    };
}

